// import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import emiImg from "../assets/emi.png"; 

// export default function EMICalculator() {
//   const [loanAmount, setLoanAmount] = useState(250000);
//   const [interestRate, setInterestRate] = useState(11);
//   const [loanDuration, setLoanDuration] = useState(8);

//   const monthlyInterest = interestRate / 12 / 100;
//   const months = loanDuration * 12;
//   const emi =
//     (loanAmount * monthlyInterest * Math.pow(1 + monthlyInterest, months)) /
//     (Math.pow(1 + monthlyInterest, months) - 1);

//   const totalPayment = emi * months;
//   const totalInterest = totalPayment - loanAmount;

//   return (
  
//     <div style={styles.pageContainer}>
//           <div className="row d-flex justify-content-center">
//           <div className="col-10">
//       <div className=" py-5">
//         <h2 className="text-center fw-bold mb-3">EMI Calculator</h2>

//         <div className="row align-items-center">
//           {/* Left Side - Form */}
//           <div className="col-md-6">
//             <div style={styles.formBox} className="me-5 pt-5">
//               {/* Loan Type */}
//               <div className="mb-4">
//                 <label className="form-label fw-semibold">Loan Type</label>
//                 <select className="form-select">
//                   <option>Personal Loan</option>
//                   <option>Home Loan</option>
//                   <option>Car Loan</option>
//                   <option>Education Loan</option>
//                 </select>
//               </div>

//               {/* Loan Amount */}
//               <div className="mb-4">
//                 <label className="form-label fw-semibold">Loan Amount</label>
//                 <input
//                   type="text"
//                   value={`₹${loanAmount.toLocaleString()}`}
//                   className="form-control mb-2"
//                   readOnly
//                 />
//                 <input
//                   type="range"
//                   min="50000"
//                   max="500000"
//                   step="10000"
//                   value={loanAmount}
//                   onChange={(e) => setLoanAmount(Number(e.target.value))}
//                   className="w-100"
//                 />
//                 <div className="d-flex justify-content-between small text-muted mt-1">
//                   <span>₹50,000</span>
//                   <span>₹5,00,000</span>
//                 </div>
//               </div>

//               {/* Loan Duration */}
//               <div className="mb-4">
//                 <label className="form-label fw-semibold">Loan Duration</label>
//                 <div className="d-flex align-items-center gap-2">
//                   <input
//                     type="number"
//                     className="form-control"
//                     style={{ width: "80px" }}
//                     value={loanDuration}
//                     onChange={(e) => setLoanDuration(Number(e.target.value))}
//                   />
//                   <button className="btn btn-light border">Yr</button>
//                   <button className="btn btn-primary text-white">Mo</button>
//                 </div>
//               </div>

//               {/* Rate of Interest */}
//               <div className="mb-4">
//                 <label className="form-label fw-semibold">Rate of Interest</label>
//                 <input
//                   type="text"
//                   value={`${interestRate}%`}
//                   className="form-control mb-2"
//                   readOnly
//                 />
//                 <input
//                   type="range"
//                   min="5"
//                   max="20"
//                   step="0.5"
//                   value={interestRate}
//                   onChange={(e) => setInterestRate(Number(e.target.value))}
//                   className="w-100"
//                 />
//                 <div className="d-flex justify-content-between small text-muted mt-1">
//                   <span>5% p.a</span>
//                   <span>20% p.a</span>
//                 </div>
//               </div>

//               <button className="btn text-white fw-semibold" style={styles.applyBtn}>
//                 Apply Now →
//               </button>
//             </div>
//           </div>

//        {/* Right Side - EMI Result */}
// <div className="col-md-6 text-center d-flex justify-content-center align-items-center mt-md-0 mt-3">
//   <img
//     src={emiImg}
//     alt="EMI Calculator"
//     className="img-fluid"
//     style={{
//       maxWidth: "100%",
//       height: "auto",
//       borderRadius: "20px",
//       objectFit: "cover",
//     }}
//   />
// </div>

//         </div>
//       </div>
//       </div></div>
//     </div>
   
//   );
// }

// const styles = {
//   pageContainer: {
//     backgroundColor: "#fce8ba",
//     minHeight: "100vh",
//   overflowX: "hidden",
//   },
//   formBox: {
//     borderRadius: "16px",
   
    
//   },
//   resultCard: {
//     backgroundColor: "#fff",
//     borderRadius: "20px",
//     padding: "30px",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//     display: "inline-block",
//   },
//   pieChart: {
//     width: "100px",
//     height: "100px",
//     margin: "0 auto",
//     position: "relative",
//   },
//   pie: {
//     width: "100%",
//     height: "100%",
//     borderRadius: "50%",
//   },
//   emiBox: {
//     backgroundColor: "#f17c58",
//     color: "#fff",
//     padding: "15px",
//     borderRadius: "12px",
//     marginTop: "20px",
//   },
//   applyBtn: {
//     backgroundColor: "#f17c58",
//     border: "none",
//     padding: "10px 20px",
//     borderRadius: "8px",
//   },
// };

import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function EMICalculator() {
  const [loanAmount, setLoanAmount] = useState(100000);
  const [interestRate, setInterestRate] = useState(12);
  const [loanTenure, setLoanTenure] = useState(12);

  const monthlyRate = interestRate / 12 / 100;

  const emi =
    (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, loanTenure)) /
    (Math.pow(1 + monthlyRate, loanTenure) - 1);

  const totalPayment = emi * loanTenure;
  const totalInterest = totalPayment - loanAmount;

  const chartData = [
    { name: "Principal", value: Number(loanAmount.toFixed(2)) },
    { name: "Interest", value: Number(totalInterest.toFixed(2)) },
  ];

  const COLORS = ["#4E56C0", "#D78FEE"];

  return (
    <div style={styles.pageContainer}>
      <div className="container py-5">
        <h2 className="text-center fw-bold mb-4">EMI Calculator</h2>

        <div className="row justify-content-center">
          {/* LEFT SIDE INPUTS */}
          <div className="col-md-6 mb-4">
            {/* Loan Amount */}
            <label className="fw-semibold">Loan Amount (₹)</label>
            <div className="d-flex gap-3 align-items-center mb-2">
              <input
                type="text"
                className="form-control"
                value={loanAmount}
                min={10000}
                max={500000}
                step={1000}
                onChange={(e) => setLoanAmount(Number(e.target.value))}
              />
              <span className="fw-bold">₹</span>
            </div>

            <input
              type="range"
              className="form-range"
              min="10000"
              max="500000"
              step="1000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(Number(e.target.value))}
            />

            <div className="d-flex justify-content-between">
              <span>₹10,000</span>
              <span>₹5,00,000</span>
            </div>

            {/* Interest Rate */}
            <label className="fw-semibold mt-4">Interest Rate (%)</label>
            <div className="d-flex gap-3 align-items-center mb-2">
              <input
                type="text"
                className="form-control"
                value={interestRate}
                min={10}
                max={30}
                step={0.5}
                onChange={(e) => setInterestRate(Number(e.target.value))}
              />
              <span className="fw-bold">%</span>
            </div>

            <input
              type="range"
              className="form-range"
              min="10"
              max="30"
              step="0.5"
              value={interestRate}
              onChange={(e) => setInterestRate(Number(e.target.value))}
            />

            <div className="d-flex justify-content-between">
              <span>10%</span>
              <span>30%</span>
            </div>

            {/* Tenure */}
            <label className="fw-semibold mt-4">Tenure (Months)</label>
            <div className="d-flex gap-3 align-items-center mb-2">
              <input
                type="text"
                className="form-control"
                value={loanTenure}
                min={6}
                max={60}
                step={1}
                onChange={(e) => setLoanTenure(Number(e.target.value))}
              />
              <span className="fw-bold">Months</span>
            </div>

            <input
              type="range"
              className="form-range"
              min="6"
              max="60"
              step="1"
              value={loanTenure}
              onChange={(e) => setLoanTenure(Number(e.target.value))}
            />

            <div className="d-flex justify-content-between">
              <span>6</span>
              <span>60</span>
            </div>
          </div>

          {/* RIGHT SIDE RESULT */}
          <div className="col-md-5">
            <div style={styles.resultCard}>
              <h5 className="fw-bold text-center mb-3">
                Your EMI Details
              </h5>

              <div className="d-flex justify-content-between my-2">
                <span>Total Loan Amount</span>
                <strong>₹{loanAmount}</strong>
              </div>

              <div className="d-flex justify-content-between my-2">
                <span>Total Interest Payable</span>
                <strong>₹{totalInterest.toFixed(2)}</strong>
              </div>

              <div className="d-flex justify-content-between my-2">
                <span>Total Amount Payable</span>
                <strong>₹{totalPayment.toFixed(2)}</strong>
              </div>

              <hr />

              <h4 className="text-center fw-bold text-primary">
                ₹{emi.toFixed(2)} <small>/ month</small>
              </h4>

              <p className="text-center mt-2" style={{ fontSize: "0.9rem" }}>
                This is an estimated EMI. Final EMI may vary.
              </p>

              <div style={{ height: "180px" }}>
                <ResponsiveContainer>
                  <PieChart>
                    <Pie
                      data={chartData}
                      dataKey="value"
                      nameKey="name"
                      outerRadius={70}
                      label
                    >
                      {chartData.map((_, index) => (
                        <Cell key={index} fill={COLORS[index]} />
                      ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pageContainer: {
    backgroundColor: "#fce8ba",
    minHeight: "100vh",
  },
  resultCard: {
    backgroundColor: "#fff",
    borderRadius: "18px",
    padding: "25px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
  },
};
